import { render, staticRenderFns } from "./TypeSacrifice.vue?vue&type=template&id=58581386&scoped=true"
import script from "./TypeSacrifice.vue?vue&type=script&lang=js"
export * from "./TypeSacrifice.vue?vue&type=script&lang=js"
import style0 from "./TypeSacrifice.vue?vue&type=style&index=0&id=58581386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58581386",
  null
  
)

export default component.exports